export default (key) => {
    const service = {}
    const { localStorage: storage } = window

    service.setCompanyData = (loginUrl) => {
        storage.setItem(key, JSON.stringify({ loginUrl }))
    }

    service.getCompanyData = () => {
        return JSON.parse(storage.getItem(key))
    }

    service.deleteCompanyData = () => {
        storage.removeItem(key)
    }

    return service
}
